export default __webpack_public_path__ + "static/media/duplicate.6dd0a7e8.svg";